function apiData(state = [] , action){
	switch(action.type){
		case 'FETCH_API_DATA':
		return Object.assign(...state, action.response)
	
		default : 
		return state;
	}
}
export default apiData;


// WEBPACK FOOTER //
// ./src/js/reducers/apiData.js